import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "prod-filter__list" };
import { useFilterStore } from "../store";
import { computed } from "vue";
import { storeToRefs } from "pinia";
import RangeItem from "./RangeItem.vue";
import OptionsList from "./OptionsList.vue";
import { FilterItemTypes } from "../types";
import TextInputItem from "./TextInputItem.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FiltersList',
    emits: ["update"],
    setup(__props) {
        const store = useFilterStore();
        const { items } = storeToRefs(store);
        const filtered = computed(() => items.value.filter(i => i.type !== FilterItemTypes.Flag));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filtered.value, (item) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                        key: item.name
                    }, [
                        (item.type === 'text')
                            ? (_openBlock(), _createBlock(TextInputItem, {
                                key: 0,
                                item: item,
                                onUpdate: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update', $event)))
                            }, null, 8 /* PROPS */, ["item"]))
                            : _createCommentVNode("v-if", true),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        (item.type === 'list' || item.type === 'filterable')
                            ? (_openBlock(), _createBlock(OptionsList, {
                                key: 1,
                                item: item,
                                onUpdate: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('update', $event)))
                            }, null, 8 /* PROPS */, ["item"]))
                            : _createCommentVNode("v-if", true),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        (item.type === 'range')
                            ? (_openBlock(), _createBlock(RangeItem, {
                                key: 2,
                                item: item,
                                onUpdate: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('update', $event)))
                            }, null, 8 /* PROPS */, ["item"]))
                            : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */));
                }), 128 /* KEYED_FRAGMENT */))
            ]));
        };
    }
});
